var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-component" }, [
    _c(
      "div",
      {
        staticClass: "user-box",
        style: {
          display: "inline-block",
          float: "right",
          width: "31px",
          textAlign: "left",
          fontSize: "16px",
          paddingTop: "2px",
        },
      },
      [
        _c("i", {
          staticClass: "el-icon-refresh reload",
          class: [_vm.reload ? "reloading" : ""],
          style: { cursor: "pointer", paddingLeft: "1px" },
          on: { click: _vm.handleReload },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }